// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IP-z","hovered":"JP-z","hoverImage":"KP-z","mainImage":"LP-z","imageNoBackground":"MP-z","fullSizeImage":"NP-z"};